"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.navReducers = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _connectedReactRouter = require("connected-react-router");

var _Nav = require("../../Nav/models/Nav");

var _ReducerRegistry = require("../ReducerRegistry");

var initialState = {
  isNavOpen: false
};
var registry = new _ReducerRegistry.ReducerRegistry(initialState);

var expandNav = function expandNav(state, action) {
  if (state.isNavOpen === true) {
    return state;
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isNavOpen: true
  });
};

registry.add(_Nav.NavActions.expandNav, expandNav);

var collapseNav = function collapseNav(state, action) {
  if (!state.isNavOpen) {
    return state;
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isNavOpen: false
  });
};

registry.add(_Nav.NavActions.collapseNav, collapseNav);

var locationChange = function locationChange(state, action) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isNavOpen: false
  });
};

registry.add(_connectedReactRouter.LOCATION_CHANGE, locationChange);
var navReducers = registry.getReducer();
exports.navReducers = navReducers;